import React, { useEffect } from 'react'

import './SubsidyPopup.scss'

/**
 * 23.12.19 차량구매신청 외부 url 사용으로 인하여 해당 파일 close
 * @file 보조금신청 Address 화면
 */
function SubsidyPopup({ setPopupShow, title, contents, callback }) {
    useEffect(() => {
        //팝업 이외 영역 스크롤 방지
        document.body.style.cssText = `position: fixed; top: -${window.scrollY}px; overflow-y: scroll; width: 100%;`

        return () => {
            const scrollY = document.body.style.top
            document.body.style.cssText = ''
            window.scrollTo(0, parseInt(scrollY || '0', 10) * -1)
        }
    }, [])

    return (
        <div className="subsidy-popup-wrap" onClick={() => setPopupShow(false)}>
            <div className="subsidy-popup-contents" onClick={e => e.stopPropagation()}>
                <h1>{title}</h1>
                <div dangerouslySetInnerHTML={{ __html: contents }}></div>
                <button
                    onClick={() => {
                        setPopupShow(false)
                        callback()
                    }}>
                    확인
                </button>
            </div>
        </div>
    )
}

export default SubsidyPopup
